import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Container,
  Row,
  Col, Badge
} from "reactstrap";
import {
  getApprovedPrescriptions,
  presc_modal_view
} from "../../actions/mqttAction";

import PropTypes, { string } from "prop-types";
import { connect as con } from "react-redux";
import isEmpty from "lodash/isEmpty";
import { TablePagination } from "react-pagination-table";
import _ from "lodash";
import { connect } from "twilio-video";
import Spinner from "../common/Spinner";

// The bulk "Approved" response also carries prescriptions that have since moved
// to "Dispensed" (those are shown in the Dispensed tab). Keep this tab to the
// ones still awaiting dispense.
const onlyApproved = list =>
  (list || []).filter(
    presc => presc && presc.rxInfo && presc.rxInfo.rxStatus === "Approved"
  );

class ApprovedComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchList: [],
      search: false,
      searchTerm: "",
      to_load: true
    };
  }

  UNSAFE_componentWillMount() {
    // this.props.getApprovedPrescriptions();
    //console.log("===========Inside Loading==============")
    //console.log("===========Approved =============="+this.props.can_load_approved)
    //console.log("=============Can be APproved==========="+this.props.can_load_approved)
    if (this.props.can_load_approved) {
      this.props.getApprovedPrescriptions()
    }
    // this.props.getApprovedPrescriptions();
    // this.setState({
    //     searchList: this.props.approvedPrescription
    // })
  }

  // UNSAFE_componentDidMount(){
  //     console.log("===========Inside Loading==============")
  //     this.props.getPrescriptions();
  // }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.mqtt.approvedPrescriptions &&
      nextProps.mqtt.approvedPrescriptions.length > 0
    ) {
      const approvedOnly = onlyApproved(nextProps.mqtt.approvedPrescriptions);
      this.setState({
        searchList: approvedOnly,
        to_load: nextProps.mqtt.approved_loading
      });
      //console.log("===========Approved Length=============="+approvedOnly.length)
      this.props.send_Approve_length(approvedOnly.length);
    }

    if (Object.keys(nextProps.mqtt.newMessage).length > 0) {
      const approvedPrescriptions = this.state.searchList;

      // if(nextProps.mqtt.newMessage.rxInfo.rxStatus==="Approved" ){
      //     approvedPrescriptions.unshift(nextProps.mqtt.newMessage);
      //   //console.log("============Inside new Message==============")

      //   this.setState({
      //     ...this.state,
      //     searchList: approvedPrescriptions
      //   });
      //   this.props.send_Approve_length(approvedPrescriptions.length)
      // }
    }
    // if (nextProps.approvedPrescription) {
    //     this.setState({
    //         searchList: nextProps.approvedPrescription
    //     })
    // }
  }

  renderConsellingLabel(requireConsult) {
    let badge;
    if (requireConsult) {
      badge = (
        <Badge color="danger" pill className="ml-1">
          CounsellingRequired
        </Badge>
      );
    }
    return badge;
  }

  renderPPMRequiredLabel(ppmRequired) {
    let badge;
    if (ppmRequired) {
      badge = (
        <Badge color="danger" pill className="ml-1">
          PMPRequired
        </Badge>
      );
    }
    return badge;
  }

  onSearch = e => {
    e.preventDefault();
    this.setState({ search: true });
    this.setState({ searchTerm: e.target.value.toLowerCase() }, () => {
      let filterApproved;
      filterApproved = _.filter(
        this.state.searchList,
        approved =>
          approved.patientInfo.firstName
            .toLowerCase()
            .includes(this.state.searchTerm) ||
          approved.patientInfo.lastName
            .toLowerCase()
            .includes(this.state.searchTerm) ||
          approved.rxInfo.prescriptionNumber
            .toLowerCase()
            .includes(this.state.searchTerm)
      );
      this.setState({ searchList: filterApproved });
    });
  };
  openModalView(draftPrescription) {
    let isView = true;
    let prescription = draftPrescription;
    let patientId = draftPrescription.patientInfo.patientId;
    let prescriptionNumber = draftPrescription.rxInfo.prescriptionNumber;
    this.props.presc_modal_view(
      isView,
      prescription,
      patientId,
      prescriptionNumber
    );
  }

  render() {
    const headers = [
      "Edit",
      "Name",
      "Prescription",
      "Branch",
      "Tab",
      "ApprovedOn"
    ];
    let approvedArray = [];
    this.state.searchList.map(approved => {
      // var moment = require('moment');
      // var testDateUtc = moment.utc(""+approved.updateAt);
      // var localDate = moment().local();
      let date = String(approved.updateAt).split(" ")[0];
      let time = String(approved.updateAt).split(" ")[1];
      approvedArray.push({
        edit: (
          <Link to='#' onClick={() => this.openModalView(approved)}>
            <i
              className="text-success fas fa-thumbs-up"
              onClick={() => this.openModalView(approved)}
            />
          </Link>
        ),
        name: (
          <Link to='#' onClick={() => this.openModalView(approved)}>
            <span className="text-capitalize">
              <strong>
                {approved.patientInfo.firstName.toUpperCase()} {approved.patientInfo.lastName.toUpperCase()}
              </strong>
              {this.renderConsellingLabel(approved.patientInfo.patientAdditionalInfo.requireConsult)}
              {this.renderPPMRequiredLabel(approved.patientInfo.patientAdditionalInfo.ppmRequired)}
              <div className="text-info">
                {approved.patientInfo.dateOfBirth}
              </div>
            </span>
          </Link>


        ),
        prescription: (
          <Link to='#' onClick={() => this.openModalView(approved)}>
            <span>
              <strong>{approved.rxInfo.prescriptionNumber}</strong>
              <div className="text-info">{approved.rxInfo.rxName}</div>
            </span>
          </Link>
        ),
        branch: (
          <div>
            {isEmpty(approved.branchName) ? "N/A" : approved.branchName}
          </div>
        ),
        tab: <span>{approved.rxInfo.rxType}</span>,
        date: (
          <span>
            {date}
            <br></br>
            <span className="text-info">{time}</span>
          </span>
        )
      });
    });

    const approved = (
      <TablePagination
        //headers={headers}
        data={approvedArray}
        columns="edit.name.prescription.branch.tab.date"
        perPageItemCount={6}
        totalCount={this.state.searchList.length}
        arrayOption={[[]]}
        className={
          "text-center table table-borderless table-striped font-style"
        }
        paginationClassName={"react-paginate"}
      />
    );

    let approv = <Spinner />;
    if (!this.state.to_load) {
      approv = (
        <div>
          <div className="py-2">
            <Row>
              <Col></Col>
              <Col></Col>
              <Col>
                <InputGroup className="mb-3">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="fas fa-search" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                    onChange={this.onSearch.bind(this)}
                  />
                </InputGroup>
              </Col>
            </Row>

            {approved}
          </div>
        </div>
      );
    }

    return approv;
  }
}

ApprovedComponent.propTypes = {
  getApprovedPrescriptions: PropTypes.func.isRequired,
  mqtt: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  presc_modal_view: PropTypes.func.isRequired
};

const mapStateToProps = state => ({ mqtt: state.mqtt, auth: state.auth });

export default con(mapStateToProps, {
  getApprovedPrescriptions,
  presc_modal_view
})(ApprovedComponent);
